<div class="item costum-mat-surface-container-lowest custom-elevation-z2">
    <div class="title-header costum-mat-primary-font-color"><span
            class="custom-title-large">Öffnungszeiten</span><mat-icon
            class="material-icons-outlined">storefront</mat-icon>
    </div>
    <div class="contact-details">
        <app-opening-hours [classes]="'custom-body-medium'"></app-opening-hours>
    </div>
</div>